import React, {Component} from 'react';
//import { Link } from 'react-router-dom';
import { connect } from "react-redux";
import './css/neonButton.css';
import './css/gradientButton.css';
import './css/loader.css';
import './css/border.css';
import './css/button.css';
import './css/card.css';
import './css/ribbon.css';
import './css/ribbon2.css';
import './css/common.css';
import './css/checkbox.css';
import './css/color.css';
import './css/container.css';
import './css/display.css';
import './css/home.css';
import './css/mis.css';
import './css/nav.css';
import './css/sidebar.css';
import './css/image.css';
import './css/dropdown.css';
import './css/summary.css';
import './css/gr.css';
import './css/react-image-gallery-copy.css';
//import './css/semantic.css'

//import ScrollBottomButton from "../scroll/ScrollBottomButton";
import ScrollTopButton from "../scroll/ScrollTopButton";
import { openModal } from "../../actions/modalAction";
import { searchReviews } from "../../actions/reviewAction";
import { searchPropOverviews } from "../../actions/propOverviewAction";
import { searchAwards } from "../../actions/awardAction";
import About from './About'
import WhyChooseUs from './WhyChooseUs'
import WhatClientSay from './WhatClientSay'
import WhatWeDealsIn from './WhatWeDealsIn'
import WhereWeDeal from './WhereWeDeal'
import Services from './Services'
import ContactUs from './ContactUs'
import WellcomeBanner from './WellcomeBanner'
//import { Image,Modal } from 'semantic-ui-react'
import Navbar from "../layout/Navbar";
// import ImageGallery from './ImageGallery'

import Awards from "./Awards";
import VidModal from './VidModal'
import QuickLink from './QuickLink'
import Footer from './Footer'
import PhoneWhatsappButton from './PhoneWhatsappButton'
// import Showcase from './Showcase'
// import AreaUnitConverter from '../common/UnitConverter/AreaUnitConverter'
// import ImageUpload from '../imageUpload/ImageUpload'
//import ImageUploadResize from '../imageUpload/ImageUploadResize'
//import AddImageVideo from '../imageUpload/AddImageVideo'
//import AddImage2 from '../imageUpload/AddImage2'
//import AddImage2_axios from '../imageUpload/AddImage2_axios'
//import HorizontalScroll from './HorizontalScrollReact/HorizontalScroll';
class Landing extends Component {
 
  componentDidMount() {
    // if(this.props.history.location.pathname ==='/'){
    //   this.props.hideBackButton()
    // }
    this.props.searchAwards()
    this.props.searchReviews({})
    this.props.searchPropOverviews()
    window.scroll(0,0)
  }

  
    

handleContactUsModal = () => {
  this.props.openModal("ContactUsModal");
};
  handlePrivacyPolicyModal = () => {
    this.props.openModal("PrivacyPolicyModal");
  };
  handleCookiesPolicyModal = () => {
    this.props.openModal("CookiesPolicyModal");
  };
  handleTermsAndConditionsModal = () => {
    this.props.openModal("TermsAndConditionsModal");
  };
  //*************** */
       
    


render() {

 
  return (
    <div id="home" >



{/*  */}
<Navbar/>
      <div className='font-family-Nunito' style={{marginTop:'0px'}} >
     {/*  */}
     
        <section>
          <WellcomeBanner handleContactUsModal= {this.handleContactUsModal}/>
        </section>
        <div >
        {/*section heading  */}
  
  {/*  */}
        <div id='about'><About/></div>
  
  {/*  */}   
  {/*section heading  */}
  <section>
  <div id='what' className='' ><WhatWeDealsIn/></div>
  </section>
  <div  className='' ><VidModal/></div>
  <div id='where' className='' ><WhereWeDeal/></div>
  <div id='service' className='' ><Services/></div>
       
  {/*section why choose us  */}
  <div id='why' className='' ><WhyChooseUs/></div>
  <div id='review' className='' ><WhatClientSay/></div>
  <div id='award' className='' ><Awards/></div>
  <div id='contact' className='' ><ContactUs/></div>
  {/* <div id='img' className='' ><ImageGallery/></div> */}
  {/* <div ><VidModal/></div> */}
  {/* <AreaUnitConverter val={1500} unit={'sq. m.'}/> */}
  {/* <ImageUpload/> */}
  {/* <AddImageVideo/> */}
 {/* <div
 style={{maxWidth:'500px', margin:'auto'}}
 > <HorizontalScroll
 style={{margin:'auto'}}
 /></div> */}
  {/* <AddImage/>
  <ImageUploadResize/>
  <AddImage2/>
  <AddImage2_axios/> */}
  <div id='' className='' >
    <QuickLink
    handlePrivacyPolicyModal={this.handlePrivacyPolicyModal}
    handleCookiesPolicyModal={this.handleCookiesPolicyModal}
    />
    </div>
  <div id='"main-footer"' className='' ><Footer/></div>
  <PhoneWhatsappButton/>
  
  {/* <div id='' className='' ><Showcase/></div> */}
</div>
</div>  

{/*  */}
{/* Footer */}
 {/* <footer id="main-footer" className="bg-dark text-center py-1">
<div className="containerP">
<div className="row" style={{border:'none'}}>
<div className="disflex-nav-footer" style={{ flex: '50%',padding: 20,flexDirection:'column'}}> */}

{/* <div className = ' border-logo '><Image size='mini' src='/logo.png'  /></div> */}
  

  {/* <div style={{display:'flex',alignItems:'center'}}>
     <Image className = ' border-logo ' size='mini' src='/logo.png' style={{ marginRight: '.5em' }} />
    <div className="font-family-Mistral" style={{fontSize:'2.2rem',fontWeight:'bold',marginRight:'5px'}}> 
    <span style={{color:'skyblue'}}>Interior</span>
  <span style={{color:'dodgerblue'}}>4</span>
  <span style={{color:'orange'}}>All</span> 
  </div>
      </div> */}
  
{/*  */}

{/*  */}
{/* <p className='flex-center' >
  <span><img className= '' src='/locationIcon1.png' alt=" " style={{width:"25px", height:"25px",borderRadius:'5px',verticalAlign:'middle',marginRight:'10px'}} />
  Plot No. 32, Pocket 1, Sector 13, Dwarka, Delhi-78, INDIA.</span></p>
<p className='flex-center' >
<span><img className= '' src='/workshopLocationIcon.jpg' alt=" " style={{width:"25px", height:"25px",borderRadius:'5px',verticalAlign:'middle',marginRight:'10px'}} />
581, Silver Oak Farms, Ghitorni, New Delhi-30, INDIA.</span></p>
   */}
{/*  */}
{/* </div>
<div className="main " style={{ flex: '50%'}}>
<nav id="navbarfoot" className="disflex-nav-footer">  */}




    {/* <ul className='disflex-nav-footer-ul'> */}


    {/* <li><a href="https://findprop.in">Home</a></li> */}
    

     {/* <li>
      <a      
      onClick={this.handleContactUsModal}
      >Contact Us
      </a>
      </li>

      <li>
      <a      
      onClick={this.handlePrivacyPolicyModal}
      >Privacy Policy
      </a>
      </li>

      <li>
      <a
      onClick={this.handleCookiesPolicyModal}
      >Cookies Policy
      </a>
      </li>

      <li>
      <a
      onClick={this.handleTermsAndConditionsModal}
      >Terms & Conditions
      </a>
      </li>

    </ul>
    </nav>

    </div>



</div>

<p > © Copyright 2022 Interior4All, All Rights Reserved</p>
<br/>
</div>
</footer>  */}

<div >
    {/* <ScrollBottomButton scrollStepInPx="11550" delayInMs="16.66"/> */}

  <ScrollTopButton />
</div>

    </div>
  );
}
}

const mapStateToProps = (state) => {
// console.log( 'state' ,state)
  return {
    auth:state.auth,
    userA: state.auth.userA,
  };
};

export default connect( 
   mapStateToProps,
 {openModal,searchReviews,searchAwards,searchPropOverviews}
)(Landing);
